// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__s0gyG","eddTitle":"PageHeader_eddTitle__nsQwQ","closeIcon":"PageHeader_closeIcon__AzEQC","dividend":"PageHeader_dividend__GLimZ"};